import { useMemo } from 'react';

import { useMembershipModalState } from '../../../../modalContext';

type HighlightTextStyles = Readonly<{
	backgroundColor: string;
	selectedBackgroundColor: string;
	borderColor: string;
	selectedBorderColor: string;
	textColor: string;
	selectedTextColor: string;
	iconColor: string;
	selectedIconColor: string;
}>;

type Result = ModelHookResult<HighlightTextStyles, undefined>;

const CONTROL_STYLES: HighlightTextStyles = {
	backgroundColor: 'sunrise.semantic.fill.weaker',
	selectedBackgroundColor: 'sunrise.semantic.fill.accent.primary.strong',
	borderColor: 'transparent',
	selectedBorderColor: 'sunrise.semantic.fill.accent.primary.weaker',
	textColor: 'sunrise.semantic.typography.strong',
	selectedTextColor: 'sunrise.semantic.typography.inverse.strong',
	iconColor: 'sunrise.semantic.icon.strong',
	selectedIconColor: 'sunrise.semantic.icon.inverse.strong',
};

const VARIANT_STYLES: HighlightTextStyles = {
	backgroundColor: 'sunrise.semantic.fill.weaker',
	selectedBackgroundColor: 'sunrise.semantic.fill.accent.primary.weaker',
	borderColor: 'transparent',
	selectedBorderColor: 'sunrise.semantic.stroke.inverse.strong',
	textColor: 'sunrise.semantic.typography.strong',
	selectedTextColor: 'sunrise.semantic.typography.accent.primary',
	iconColor: 'sunrise.semantic.icon.strong',
	selectedIconColor: 'sunrise.semantic.icon.accent.primary',
};

export function useHighlightText(): Result {
	const [{ koiPpmuDesignExperimentVariant }] = useMembershipModalState();

	const data = useMemo(() => {
		return koiPpmuDesignExperimentVariant === 'variant_3' ? VARIANT_STYLES : CONTROL_STYLES;
	}, [koiPpmuDesignExperimentVariant]);

	return { data };
}
